import { Bot, UserCircle } from 'lucide-react';
import { BotPicker } from './BotPicker';
import { useAuth } from '../../../hooks/useAuth';

interface RunAsSelectorProps {
  selected: string;
  onChange: (botExternalId: string) => void;
}

export function RunAsSelector({ selected, onChange }: RunAsSelectorProps) {
  const { user, isSuperAdmin, hasRoleType } = useAuth();
  const isAdmin = isSuperAdmin || hasRoleType('admin');

  return (
    <div>
      {isAdmin ? (
        <BotPicker selected={selected} onChange={onChange} />
      ) : (
        <div className="flex items-center gap-1.5">
          {selected ? (
            <>
              <Bot className="w-3 h-3 text-accent/75 shrink-0" strokeWidth={1.5} />
              <span className="text-[10px] text-text-secondary">
                Running as <span className="font-medium text-accent font-mono">{selected}</span>
              </span>
            </>
          ) : (
            <>
              <UserCircle className="w-3 h-3 text-accent/75 shrink-0" strokeWidth={1.5} />
              <span className="text-[10px] text-text-secondary">
                Running as <span className="font-medium text-accent">{user?.displayName || user?.userId || 'you'}</span>
              </span>
            </>
          )}
        </div>
      )}
    </div>
  );
}
